import Store from "@ember-data/store";
import Patient from "core/models/patient";
export default async function fetchChatMessageJes(store, patient, page = 1, nbByPage = 10) {
  const response = await store.query("patient-chat-message-sent-journal-event", {
    filter: {
      patient_id: patient.id
    },
    include: ["creator", "triggering-journal-event.file-attachments", "triggering-journal-event.creator"].join(","),
    page: {
      number: page,
      size: nbByPage
    },
    sort: "-occurred_at"
  });
  return {
    pageCount: parseInt(response.meta?.["page-count"]) || undefined
  };
}